import Icon from 'components/Icon/Icon';
import {
  Container,
  IconWrapper,
  LeftSide,
  Middle,
  Name,
  RadioButton,
  RadioText,
  RightSide,
} from './FieldsComponents.styled';
import {
  Circle,
  CurrencyCircleDollar,
  DotsSixVertical,
  Info,
  Trash,
} from '@phosphor-icons/react';
import { COLORS } from 'assets/styled';
import { ICustomModel, IRadioInputField } from 'types/Builder.types';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/Tooltip/Tooltip';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';

interface IProps {
  field: IRadioInputField;
  model: ICustomModel;
  onDelete: () => void;
  drag?: React.Ref<any>;
  onDragStart: () => void;
}

const RadioField = ({ field, model, onDelete, drag, onDragStart }: IProps) => {
  const { t } = useTranslation();
  const { isTablet } = useBreakpointFlag();

  const currentField = model.input_fields.find(
    (f) => f.id === field.id
  ) as IRadioInputField;

  return (
    <Container ref={drag}>
      <LeftSide>
        <IconWrapper
          ref={drag}
          onMouseDown={(e: any) => {
            e.stopPropagation();
            onDragStart();
          }}
          onTouchStart={(e: any) => {
            e.stopPropagation();
            onDragStart();
          }}
        >
          <Icon
            svg={DotsSixVertical}
            color={COLORS.GREEN}
            size={30}
            weight="regular"
          />
        </IconWrapper>
        <Name>
          {field.field_label}
          {!!field.description.length && (
            <Tooltip content={field.description}>
              <Icon
                svg={Info}
                color={COLORS.GREEN}
                size={20}
                weight="regular"
              />
            </Tooltip>
          )}
          {(currentField.id === model.price_matrices[0].x_axis_id ||
            currentField.id === model.price_matrices[0].y_axis_id) && (
            <Tooltip content={t('Input field has impact on price')}>
              <Icon
                svg={CurrencyCircleDollar}
                color={COLORS.GREEN}
                size={20}
                weight="regular"
              />
            </Tooltip>
          )}
        </Name>
      </LeftSide>
      <Middle>
        {currentField.default !== null &&
          currentField.options[currentField.default]?.name && (
            <RadioButton>
              <Icon
                svg={Circle}
                color={COLORS.GREEN}
                weight={'fill'}
                size={25}
                disabled
              />
              <RadioText>
                {currentField.options[currentField.default]?.name}
              </RadioText>
            </RadioButton>
          )}
      </Middle>
      <RightSide>
        <Tooltip
          content={
            currentField.id === model.price_matrices[0].x_axis_id ||
            currentField.id === model.price_matrices[0].y_axis_id
              ? t('Input field is used in matrix')
              : undefined
          }
        >
          <Icon
            svg={Trash}
            color={COLORS.RED_100}
            size={isTablet ? 20 : 30}
            weight="regular"
            onClick={onDelete}
            disabled={
              currentField.id === model.price_matrices[0].x_axis_id ||
              currentField.id === model.price_matrices[0].y_axis_id
            }
          />
        </Tooltip>
      </RightSide>
    </Container>
  );
};

export default RadioField;
